export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`text-xs font-semibold uppercase tracking-[0.2em] text-brand-orange ${className}`}
  >
    {children}
  </p>
);
